import React from 'react';

export const RecurringFilters = ({ searchTerm, setSearchTerm, statusFilter, setStatusFilter }) => {
    return (
        <div className="d-flex flex-column flex-md-row gap-3 mb-4 p-3 bg-white shadow-sm rounded">
            <div className="flex-grow-1">
                <label className="form-label fw-bold small text-muted">Buscar por ID, nombre o correo</label>
                <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                        <i className="bi bi-search"></i>
                    </span>
                    <input 
                        type="text" 
                        className="form-control bg-light border-start-0" 
                        placeholder="Escribe aquí..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>
            
            <div style={{ minWidth: '200px' }}>
                <label className="form-label fw-bold small text-muted">Filtrar por Estado</label>
                <select 
                    className="form-select bg-light" 
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                >
                    <option value="">Todos los estados</option>
                    <option value="Activo">Activo</option>
                    <option value="Pausado">Pausado</option>
                    <option value="Cancelado">Cancelado</option>
                </select>
            </div>
        </div>
    );
};
